import { Grid, Link, MenuItem, TextField, Typography } from "@material-ui/core";
import { applicationContext, appUserContext } from "helpers/services";
import { useContext } from "react";
import { Autocomplete } from '@material-ui/lab';
import { ticketContext } from "../../TicketContext";
import { WhosNext, UserType } from "helpers/enums";


let Editable = () => {
    let { userGroups, customerServiceUsers, ticketStatuses, ticketPriorities } = useContext(applicationContext);
    let { currentUser } = useContext(appUserContext);
    let service = useContext(ticketContext);

    return (
        <>
            <Grid container>
                <Grid item xs>
                    <TextField
                        label="Ticket status"
                        fullWidth
                        select
                        variant="outlined"
                        value={service.ticket.ticketStatusId}
                        onChange={(e) => service.updateTicketStatus(e.target.value)}
                    >
                        {ticketStatuses.map(status =>
                            <MenuItem key={status.id} value={status.id}>
                                {currentUser?.typology === UserType.VitecUser ? status.name : status.customerStatus}
                            </MenuItem>
                        )}
                    </TextField>
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs>
                    {currentUser?.canWorkOnAllTicket &&
                        <TextField
                            label="Ticket priority"
                            fullWidth
                            select
                            variant="outlined"
                            value={service.ticket.ticketPriorityId}
                            onChange={(e) => service.updateTicketPriority(e.target.value)}
                        >
                            {ticketPriorities.map(priority =>
                                <MenuItem key={priority.id} value={priority.id}>{priority.description}</MenuItem>
                            )}
                        </TextField>
                    }
                    {currentUser?.canWorkOnAllTicket === false &&
                        <>
                            <Typography variant="subtitle2"><b>Ticket priority</b></Typography>
                            <Typography variant="body1">{ticketPriorities.find(x => x.id === service.ticket.ticketPriorityId)?.description}</Typography>
                        </>
                    }
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs>
                    {currentUser?.canWorkOnAllTicket &&
                        <TextField
                            label="Who's Next"
                            fullWidth
                            select
                            variant="outlined"
                            value={service.ticket.whosNext}
                            onChange={(e) => service.updateWhosNext(e.target.value as WhosNext)}
                        >
                            <MenuItem value={WhosNext.Videndum}>{WhosNext.Videndum}</MenuItem>
                            <MenuItem value={WhosNext.Reporter}>{WhosNext.Reporter}</MenuItem>
                        </TextField>}
                    {currentUser?.canWorkOnAllTicket === false &&
                        <>
                            <Typography variant="subtitle2"><b>Who's Next</b></Typography>
                            <Typography variant="body1">{service.ticket.whosNext}</Typography>
                        </>
                    }
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs>
                    {currentUser?.canWorkOnAllTicket &&
                        <>
                            <Autocomplete
                                value={service.ticket.customerServiceAssignee}
                                onChange={(e, newValue) => service.updateCustomerServiceAssignee(newValue || "")}

                                getOptionLabel={(option) => customerServiceUsers.getValueByKey(option)}
                                options={customerServiceUsers.map(x => x.key)}
                                renderInput={(params) =>
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        fullWidth
                                        label="Customer service assignee"
                                    />
                                }
                            />
                            {currentUser?.groups?.indexOf("CUSTOMER_SERVICE") !== -1 &&
                                currentUser?.email !== service.ticket.customerServiceAssignee &&
                                <Link
                                    color="error"
                                    variant="body2"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => service.updateCustomerServiceAssignee(currentUser?.email || "")}
                                >
                                    Assign to me
                                </Link>
                            }
                        </>
                    }
                    {currentUser?.canWorkOnAllTicket === false &&
                        <>
                            <Typography variant="subtitle2"><b>Customer service assignee</b></Typography>
                            <Typography variant="body1">{service.ticket.reporter}</Typography>
                        </>
                    }
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs>
                    <Autocomplete
                        value={service.ticket.assignee}
                        onChange={(e, newValue) => service.updateAssignee(newValue || "")}
                        getOptionLabel={(option) => service.assignableUsers.getValueByKey(option, 'email', 'name')}
                        options={service.assignableUsers.map(x => x.email)}
                        renderInput={(params) =>
                            <TextField
                                {...params}
                                variant="outlined"
                                fullWidth
                                label="Assignee"
                            />
                        }
                    />
                    {currentUser?.email !== service.ticket.assignee &&
                        <Link
                            role="button"
                            color="error"
                            variant="body2"
                            style={{ cursor: 'pointer' }}
                            onClick={() => service.updateAssignee(currentUser?.email || "")}
                        >
                            Assign to me
                        </Link>
                    }
                </Grid>
            </Grid>
            <Grid container >
                <Grid item xs>
                    {currentUser?.canWorkOnAllTicket &&
                        <TextField
                            label="Groups"
                            fullWidth
                            select
                            SelectProps={{ multiple: true }}
                            variant="outlined"
                            value={service.ticket.groups}
                            onChange={(e: any) => {
                                let currentAssignee = service.assignableUsers.find(x => x.email === service.ticket.assignee);

                                // se il ticket e' assegnato
                                // sto rimuovendo un grouppo 
                                // l' assignee ha dei grouppi 
                                // il grouppo che sto rimuovedndo e' uno dei grouppi dell' assignee

                                if (currentAssignee
                                    && currentAssignee.groups.length > 0
                                    && service.ticket.groups.length > e.target.value.length
                                    && !currentAssignee.groups.find(x => e.target.value.indexOf(x) !== -1)) {

                                    let text = "Removing this group will change the assignee";
                                    text += ` from '${currentAssignee.name}' `;
                                    text += "to 'Unassigned'. Do you want to proceed?";

                                    if (window.confirm(text)) {
                                        service.updateGroups(e.target.value || [])
                                    }
                                } else {
                                    service.updateGroups(e.target.value || [])
                                }

                            }}
                        >
                            {userGroups.map(group =>
                                <MenuItem key={group.key} value={group.key}>{group.value}</MenuItem>
                            )}
                        </TextField>
                    }
                    {currentUser?.canWorkOnAllTicket === false &&
                        <>
                            <Typography variant="subtitle2"><b>Groups</b></Typography>
                            <Typography variant="body1">
                                {userGroups.filter(x => service.ticket.groups.indexOf(x.key) !== -1).map(x => x.value).join(", ")}
                            </Typography>
                        </>
                    }
                </Grid>
            </Grid>
        </>
    )
}

export default Editable;